<script setup lang="ts">
import {
  IPortfolioRecomendation,
  IStarRatingCard,
} from '@/interface/portfolio/IPortfolioRecomendation'
import RecomendationCard from '@/components/portfolio/RecomendationCard.vue'
import PaginationComponent from '@/components/PaginationComponent.vue'
import ImgComponent from '@/components/media/ImgComponent.vue'
import { useWindow } from '@/composables/useWindow'

interface Props {
  recomendation: IPortfolioRecomendation
  starRatingCard: IStarRatingCard[]
}
const screen = useWindow()

const computeRevievCountBasedOnBreakpoint = (screenWidth: number) => {
  if (screenWidth < 768) return 1
  if (screenWidth < 1024) return 2
  if (screenWidth < 1280) return 3
  return 4
}

defineProps<Props>()
</script>

<template>
  <ApplicationContainer
    :title="recomendation.title"
    :describe="recomendation.copy"
    id="ourRecomendations"
  >
    <div>
      <ImgComponent
        v-if="recomendation.image"
        :src="recomendation.image"
        class="mt-8 mx-auto max-h-[70px]"
      />
      <PaginationComponent
        :page-size="computeRevievCountBasedOnBreakpoint(screen.width)"
        :item-list="starRatingCard"
        scroll-to="ourRecomendations"
        v-slot="{ items }"
      >
        <div class="flex my-8 gap-6 justify-around wrapper">
          <RecomendationCard
            v-for="elem in (items as IStarRatingCard[])"
            :key="elem.id"
            :recomendation="elem"
            class="card--blue p-4 rounded-lg w-[90%] sm:w-[47%] lg:w-[22%]"
          />
        </div>
      </PaginationComponent>
    </div>
  </ApplicationContainer>
</template>

<style scoped lang="scss">
.wrapper {
  div:not(:first-child) {
    display: none;
  }

  @media screen and (min-width: 768px) {
    div:nth-child(2) {
      display: block;
    }
  }

  @media screen and (min-width: 1024px) {
    div:nth-child(3) {
      display: block;
    }
  }

  @media screen and (min-width: 1280px) {
    div {
      display: block;
    }
  }
}
</style>
